<app-carousel />
<app-why-us />
<app-pricing />
<app-search />
<app-get-started />
<app-explore />
<app-milestones />
<app-play-store />

@if (crossComponentService.homePopup()) {
<app-home-popup />
}